export const Themes = [
   "Fullspeed",
   "Fullspeed",
   "Tech",
   "Tech",
   "Tech",
   "LOL",
   "Speed Tech",
   "Speed Tech",
   "Offroad",
   "Ice",
   "Ice",
   "Dirt",
   "Dirt",
   "Dirt",
   "Stunt",
   "Reactor",
   "Mixed",
   "Nascar",
   "Transitional",
   "Transitional",
   "Grass",
   "Grass",
   "Water",
   "Plastic",
   "Plastic",
   "Sausage",
   "Sausage",
   "Bobsleigh",
   "Alt Car",
   "Alt Car",
   "Snowcar",
   "Wood",
   "Wood",
   "Rallycar",
   "Mixedcar",
   "Bugslide",
   "Desertcar",
   "Effect blocks",
   "Puzzle"
];

export const Restrictions = [
   "Multilap",
   "You can't use the same block twice",
   "Max 15 block types",
   "Reuse a part of the track",
   "There has to be a risky finish",
   "You have to create a little animal from the colored building blocks",
   "There needs to be a half pipe",
   "You can only have one checkpoint max",
   "Use night time",
   "The map must have a little easter egg",
   "Use a block you've never used before",
   "The car must be airborne at least 5 times during the route",
   "You can't use ghost blocks",
   "Scenery must change colors in between zones",
   "The full map needs to be inside a cube of 8x8x8",
   "The player must jump through a checkpoint ring",
   "Play a random map before editing and copy one feature of it",
   "You can't use any 1x1 block",
   "Your map needs to have obstacles",
   "You have to use turbo",
   "You have to use reactor boost up",
   "You have to use reactor down",
   "You have to use cruisecontrol",
   "You have to use nobrakes",
   "You have to use engine off",
   "You have to use no steer",
   "You have to spend more time on the environment than the track",
   "It has to be an 08 map",
];